export default function CTASection() {
  return (
    <section className="relative w-full min-h-[70vh] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Bright%20sunlit%20corner%20of%20a%20modern%20concept%20store%20with%20curated%20minimal%20product%20arrangements%2C%20large%20arched%20window%2C%20warm%20natural%20light%2C%20polished%20concrete%20floor%2C%20indoor%20plants%2C%20soft%20earth%20tone%20palette%2C%20inviting%20retail%20atmosphere%2C%20editorial%20interior%20photography&width=1600&height=900&seq=cta-retail-v3&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-black/30"></div>

      <div className="relative z-10 text-center px-4 max-w-3xl mx-auto">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 tracking-wide">
          READY TO SHOP SMARTER?
        </h2>
        <p className="text-background-50/80 text-sm md:text-base mb-10 leading-relaxed">
          Jump to our main store and explore
          <br />
          the full curated collection today.
        </p>

        <div className="inline-flex">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="flex items-center bg-foreground-900 hover:bg-foreground-800 text-background-50 rounded-full transition-colors overflow-hidden"
          >
            <span className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-shopping-bag-line text-background-50 text-lg"></i>
              </span>
            </span>
            <span className="px-6 md:px-8 font-semibold text-sm md:text-base uppercase tracking-wide whitespace-nowrap">
              GO TO KASPREADSHEET.COM
            </span>
            <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center pr-2">
              <i className="ri-arrow-right-up-line text-background-50/60 text-lg"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}